import { render } from "./InfoBarControl.vue?vue&type=template&id=45cd4bcc&scoped=true"
import script from "./InfoBarControl.vue?vue&type=script&lang=js"
export * from "./InfoBarControl.vue?vue&type=script&lang=js"

import "./InfoBarControl.vue?vue&type=style&index=0&id=45cd4bcc&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cd4bcc"]])

export default __exports__